<template>
  <div id="mz-redemption-status-modal" class="uk-flex-top" uk-modal>
    <div class="uk-modal-dialog uk-modal-body">
      <h2 class="uk-modal-title uk-text-center">{{ title }}</h2>
      <div v-if="type === 'redemption-confirm'">
        <p>{{ $t("Areyousureyouwanttoredeem") }}</p>
        <p class="uk-text-center">
          <button v-on:click="yesRedemption(data)" class="uk-button uk-button-primary uk-modal-close" type="button">{{ $t("Yes") }}</button>
          <button class="uk-button uk-button-default uk-modal-close" type="button">{{ $t("No") }}</button>
        </p>
      </div>
      <div v-if="type === 'loyalty-redeem'">
        <h3 class="uk-text-center">
          {{ $t("REDEMPTIONSUCCESSFUL") }}
        </h3>
        <h4 class="uk-text-center">
          {{data.name}}
        </h4>
        <div class="uk-text-center">
          <strong>{{data.reward_threshold}}/{{data.reward_threshold}}</strong>
        </div>
<!--                <div class="uk-text-center">-->
<!--                  <p>{{ $t("TrackingCode" )}}</p>-->
<!--                  <strong>{{data.loyalty_redemption.data.id_hash}}</strong>-->
<!--                </div>-->
        <!--        <div class="uk-text-center">-->
        <!--          <qrcode :value="data.loyalty_redemption.data.id_hash" :options="{ width: 150 }"></qrcode>-->
        <!--        </div>-->
        <p class="uk-text-center">
          <button class="uk-button uk-button-secondary uk-modal-close" type="button">{{ $t("Close") }}</button>
        </p>
      </div>
      <div v-if="type === 'voucher-redeem'">
        <h3 class="uk-text-center">
          {{ $t("REDEMPTIONSUCCESSFUL") }}
        </h3>
        <h4 class="uk-text-center">
          {{data.offer_tmp.name}}
        </h4>
        <div v-if="appConfigs.plu_on_redemtpion === true && data.offer_tmp.plu_code !== 'null'" class="uk-text-center">
          <p>{{ $t("PLU Code" )}}</p>
          <strong>{{data.offer_tmp.plu_code}}</strong>
        </div>
        <div v-else class="uk-text-center">
<!--          <p>{{ $t("TrackingCode" )}}</p>-->
<!--          <strong>{{data.id_hash}}</strong>-->
        </div>
        <p class="uk-text-center">
          <button class="uk-button uk-button-secondary uk-modal-close" type="button">{{ $t("Close") }}</button>
        </p>
      </div>
      <div v-if="type === 'loyalty-added'">
        <h3 class="uk-text-center">
          <p>Paul, Thanks for shopping with us today. Congratulations, Paul you have {{ loyalty_amount}} points.</p>
          <progress id="js-progressbar" class="uk-progress" :value="loyalty_amount" max="2500"></progress>
          <h4 class="uk-text-center">You only need {{(500 * 5) - loyalty_amount}} more points to receive next reward. </h4>
        </h3>
        <p class="uk-text-center">
          <button class="uk-button uk-button-secondary uk-modal-close" type="button">{{ $t("No") }}</button>
        </p>
      </div>
      <div v-if="type === 'error'">
        <h4 class="uk-text-center">
          {{ $t(data) }}
        </h4>
        <p class="uk-text-center">
          <button class="uk-button uk-button-secondary uk-modal-close" type="button">{{ $t("Close") }}</button>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import UIkit from 'uikit'
import Hub from '../events/Hub'
import Loyalty from '../models/MZLoyalty'
import Coupon from '../models/MZCoupon'
import coreMixin from '../mixins/coreMixin'
export default {
  name: 'redemptionstatusmodal',
  mixins: [coreMixin],
  data () {
    return {
      title: null,
      redemption_type: null,
      type: null,
      type_name: null,
      data: null,
      loyalty_amount: 0
    }
  },
  methods: {
    yesRedemption (data) {
      let _this = this
      _this.close()
      if (data) {
        _this.redemptionIntent(data.method, data.intent, data.requestPayload)
      }
    },
    close () {
      UIkit.modal('#mz-redemption-status-modal').hide()
    },
    open () {
      UIkit.modal('#mz-redemption-status-modal').show()
    },
    errorResponse (data) {
      let _this = this
      _this.data = data.data.error.message
      _this.type = 'error'
      _this.title = 'Error'
      this.open()
    },
    setLoyaltyEarn (data) {
      let _this = this
      _this.data = data.data.data
      // console.log(_this.data)
      _this.item = Loyalty.query().find(_this.data.loyalty_program_id)
      _this.storeId = _this.data.store_id
      // console.log(_this.item)
      _this.id_hash = data.data.data.id_hash
      // console.log(data.data.data)
      // this.open()
      this.$router.push('/loyalty/' + _this.data.loyalty_program_id + '/location/' + _this.storeId)
    },
    setLoyaltyRedeem (data) {
      console.log('Loyalty Redeem')
      console.log(data)
      let _this = this
      _this.type = 'loyalty-redeem'
      _this.type_name = 'loyalty reward'
      _this.title = ' '
      // _this.title = 'Show to Cashier'
      _this.data = data.data.data
      this.open()
    },
    setVoucherRedeem (data) {
      console.log('Voucher Redeem')
      console.log(data.data.data)
      let _this = this
      _this.type = 'voucher-redeem'
      _this.type_name = 'coupon'
      _this.title = ' '
      _this.data = data.data.data
      _this.id = _this.$route.params.id
      _this.data.coupon = Coupon.query().find(_this.id)

      this.open()
    },
    loyaltyAdded (amount) {
      console.log('loyaltyAdded')
      let _this = this
      _this.type = 'loyalty-added'
      _this.title = 'Loyalty Transaction'
      _this.loyalty_amount = amount
      this.open()
    },
    setUserQuestion (data) {
      console.log('Ask User')
      let _this = this
      _this.type = 'redemption-confirm'
      _this.title = this.$i18n.t('Redemption')
      _this.redemption_type = data.intent
      _this.data = data
      switch (_this.redemption_type) {
        case 'redeem-loyalty':
          _this.type_name = 'loyalty reward'
          break
        case 'redeem-voucher':
          _this.type_name = 'coupon'
          break
      }
      this.open()
    }
  },
  mounted () {
    this.$nextTick(function () {
      Hub.$on('post-loyalty-earn-response-success', this.setLoyaltyEarn)
      Hub.$on('post-loyalty-redeem-response-success', this.setLoyaltyRedeem)
      Hub.$on('post-voucher-redemption-response-success', this.setVoucherRedeem)
      Hub.$on('prompt-if-user-wants-redemption', this.setUserQuestion)
      Hub.$on('loyalty-dollartx-added', this.loyaltyAdded)

      // errors
      Hub.$on('post-voucher-redemption-response-fail', this.errorResponse)
      Hub.$on('post-loyalty-earn-response-fail', this.errorResponse)
    }.bind(this))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RedemptionStatusModal.vue